export default {
  key: 'nextjs',
  lang: 'javascript',
  generate: ({ baseUrl, websiteToken }) => `// app/components/TolaWidget.jsx
'use client';

import Script from 'next/script';

const BASE_URL = '${baseUrl}';
const WEBSITE_TOKEN = '${websiteToken}';

export default function TolaWidget() {
  return (
    <Script
      id="tola-sdk"
      src={BASE_URL + '/packs/js/sdk.js'}
      strategy="lazyOnload"
      onLoad={() => {
        window.tolaSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
      }}
    />
  );
}

// The "id" makes next/script load the SDK once per session, so no extra guard
// is needed. Swap strategy to "afterInteractive" to boot the widget earlier.
//
// Usage — app/layout.jsx (or layout.tsx):
//
// import TolaWidget from './components/TolaWidget';
//
// export default function RootLayout({ children }) {
//   return (
//     <html lang="en">
//       <body>
//         {children}
//         <TolaWidget />
//       </body>
//     </html>
//   );
// }
`,
};
